// 서버에서 내려오는 error code 중 별도의 처리가 필요한 경우, 아래에 추가하여 상수로 관리
export const ERROR_CODE = {
  // 줄겨찾기
  FAVORITE_PROBLEM_CREATION_NOT_ALLOWED: 'FAVORITE_PROBLEM_CREATION_NOT_ALLOWED',
  FAVORITE_DESIGN_TEMPLATE_LIMIT_EXCEEDED: 'FAVORITE_DESIGN_TEMPLATE_LIMIT_EXCEEDED',
  // 학원 상태가 로그인 불가능한 경우
  ACADEMY_STATUS_NOT_ELIGIBLE_TO_LOGIN: 'ACADEMY_STATUS_NOT_ELIGIBLE_TO_LOGIN',
  // 접근 불가/삭제된 나의DB 문항으로 추천 요청한 경우
  MYDB_PROBLEM_DETAIL_NOT_FOUND: 'MYDB_PROBLEM_DETAIL_NOT_FOUND',
  // 문제 추천·학습지/교재 생성 횟수가 임계를 넘어 캡차 인증을 요구받은 경우
  CAPTCHA_REQUIRED: 'CAPTCHA_REQUIRED',
  // 캡차 누적 실패로 교사 단위 차단된 경우. 캡차를 통과해도 차단이 우선한다
  CAPTCHA_BLOCKED: 'CAPTCHA_BLOCKED',
  // 챌린지 발급 시점에는 캡차가 필요 없는 경우(고정 창 만료·정책 비활성).
  // 캡차 요구와 같은 코드로 내려오면 모달이 스스로를 다시 띄우게 되므로 분리되어 있다
  CAPTCHA_NOT_REQUIRED: 'CAPTCHA_NOT_REQUIRED',
  // 타 서비스 이용 동의 — 같은 400 이라도 뜻이 달라 상태코드가 아니라 code 로 갈라야 한다
  SERVICE_TYPE_ACCESS_REQUEST_REQUIRED: 'SERVICE_TYPE_ACCESS_REQUEST_REQUIRED',
  SERVICE_TYPE_LOGIN_BLOCKED: 'SERVICE_TYPE_LOGIN_BLOCKED',
  SERVICE_TYPE_NOT_AVAILABLE: 'SERVICE_TYPE_NOT_AVAILABLE',
  EXIST_SERVICE_TYPE_SUBSCRIPTION: 'EXIST_SERVICE_TYPE_SUBSCRIPTION',
  // 권한은 부여됐다가 이용권 지급이 실패해 권한까지 롤백된 경우. 재시도가 유효하다
  ENGLISHFLAT_ENTITLEMENT_GRANT_FAILED: 'ENGLISHFLAT_ENTITLEMENT_GRANT_FAILED',
  // 타 서비스 전환 검사
  SERVICE_TYPE_NOT_SUBSCRIBED: 'SERVICE_TYPE_NOT_SUBSCRIBED',
  ENGLISHFLAT_ENTITLEMENT_REQUIRED: 'ENGLISHFLAT_ENTITLEMENT_REQUIRED',
  // 빌링 조회 자체가 실패한 경우(fail-closed). 매쓰플랫 서버가 503 을 code 까지 원문 중계한다
  ENTITLEMENT_CHECK_UNAVAILABLE: 'ENTITLEMENT_CHECK_UNAVAILABLE',
}
